import React from 'react';

import { SkeletonElement } from '../../styles/SkeletonStyles';

const Skeleton = ({ id, type, width, height, margin }) => {
  return (
    <SkeletonElement id={id} type={type} width={width} height={height} margin={margin}>
      <div className='shimmer-wrapper'>
        <div className='shimmer'></div>
      </div>
    </SkeletonElement>
  );
};

export default Skeleton;
